// extracted by mini-css-extract-plugin
export default {"shippingModalLink":"ModalLink-module-shippingModalLink","label":"ModalLink-module-label"};